// A list of all locales that are supported
export const locales = ["en", "th"] as const;

export type Locale = (typeof locales)[number];

// Used when no locale matches
export const defaultLocale = "th" as const;

// This cookie name is used by `next-intl` on the public pages too. By
// reading/writing to this locale, we can ensure that the user's locale
// is consistent across public and private pages.
export const COOKIE_NAME = "PANICH_LOCALE";
